import { useCallback } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { getMyTeam, getSellectedSeller } from 'features/views/dashboard/statistics/selectors';
import { setSelectedSeller } from 'features/views/dashboard/statistics/slice';

import MyTeamTableRow from './MyTeamTableRow';

export const MyTeamTableBody = () => {
	const dispatch = useDispatch();

	const myTeam = useSelector(getMyTeam);
	const selectedSeller = useSelector(getSellectedSeller);

	const handleSellerSelectChange = useCallback(
		(seller) => () => {
			dispatch(setSelectedSeller(seller));
		},
		[dispatch],
	);

	return (
		<TableBody>
			<TableRow onClick={handleSellerSelectChange(null)}>
				<TableCell>
					<FormControlLabel control={<Radio size="small" checked={isNilOrEmpty(selectedSeller)} />} />
				</TableCell>
				<TableCell colspan={4}>{getMessage('dashboard:statistics.myTeam')}</TableCell>
			</TableRow>
			{myTeam.map((seller) => (
				<MyTeamTableRow
					key={seller.login}
					seller={seller}
					onClick={handleSellerSelectChange}
					selectedSeller={selectedSeller}
				/>
			))}
		</TableBody>
	);
};

export default MyTeamTableBody;
